import { useCallback, useState } from "react";

const FAVORITOS_KEY = "mitico_favoritos_productos";

const leerFavoritosGuardados = () => {
  try {
    const favoritosGuardados = localStorage.getItem(FAVORITOS_KEY);

    if (!favoritosGuardados) {
      return [];
    }

    const favoritosParseados = JSON.parse(favoritosGuardados);

    if (!Array.isArray(favoritosParseados)) {
      return [];
    }

    return favoritosParseados.filter(Boolean);
  } catch (error) {
    console.error("Error leyendo favoritos:", error);
    return [];
  }
};

function useFavoritosCliente() {
  const [favoritosIds, setFavoritosIds] = useState(leerFavoritosGuardados);

  const guardarFavoritos = useCallback((nuevosFavoritos) => {
    setFavoritosIds(nuevosFavoritos);
    localStorage.setItem(FAVORITOS_KEY, JSON.stringify(nuevosFavoritos));
  }, []);

  const esFavorito = useCallback(
    (productoId) => {
      return favoritosIds.includes(productoId);
    },
    [favoritosIds],
  );

  const toggleFavorito = useCallback(
    (productoId) => {
      if (!productoId) return;

      const yaExiste = favoritosIds.includes(productoId);

      const nuevosFavoritos = yaExiste
        ? favoritosIds.filter((id) => id !== productoId)
        : [...favoritosIds, productoId];

      guardarFavoritos(nuevosFavoritos);
    },
    [favoritosIds, guardarFavoritos],
  );

  return {
    favoritosIds,
    esFavorito,
    toggleFavorito,
  };
}

export default useFavoritosCliente;
